/** Shared target sizes for glyph tiles inside a collection of surfaces, in logical pixels. */
export const SURFACE_TILE_MIN_SIZE = 40;
export const SURFACE_TILE_MAX_SIZE = 64;
export const SURFACE_GRID_GAP = 4;
const PREFERRED_TILE_COLUMNS = 8;
// Seven still fits two surfaces beside the camera inset and rail on smaller landscape phones.
const MINIMUM_SURFACE_TILE_COLUMNS = 7;
// Surface borders plus a 4px gutter on either side of the glyph grid.
const SURFACE_HORIZONTAL_INSET = 10;

/** Also applies to a single surface whose body is virtualized separately from its header. */
export function getSurfaceTileGridLayout(
  surfaceWidth: number,
  horizontalInset = SURFACE_HORIZONTAL_INSET,
) {
  const tileGridWidth = Math.max(1, surfaceWidth - horizontalInset);
  const minimumColumns = Math.ceil(
    (tileGridWidth + SURFACE_GRID_GAP) / (SURFACE_TILE_MAX_SIZE + SURFACE_GRID_GAP),
  );
  const maximumColumns = Math.max(
    1,
    Math.floor((tileGridWidth + SURFACE_GRID_GAP) / (SURFACE_TILE_MIN_SIZE + SURFACE_GRID_GAP)),
  );
  const glyphColumns = Math.max(minimumColumns, Math.min(PREFERRED_TILE_COLUMNS, maximumColumns));
  const tileSize = (tileGridWidth - (glyphColumns - 1) * SURFACE_GRID_GAP) / glyphColumns;
  return { glyphColumns, tileSize };
}

/** Fit whole surfaces first, then keep their glyph tiles within the same bounds at any width. */
export function getSurfaceGridLayout(width: number) {
  const availableWidth = Math.max(1, width);
  const minimumSurfaceWidth =
    MINIMUM_SURFACE_TILE_COLUMNS * SURFACE_TILE_MIN_SIZE +
    (MINIMUM_SURFACE_TILE_COLUMNS - 1) * SURFACE_GRID_GAP +
    SURFACE_HORIZONTAL_INSET;
  const surfaceColumns = Math.max(
    1,
    Math.floor((availableWidth + SURFACE_GRID_GAP) / (minimumSurfaceWidth + SURFACE_GRID_GAP)),
  );
  const surfaceWidth = (availableWidth - (surfaceColumns - 1) * SURFACE_GRID_GAP) / surfaceColumns;
  const { glyphColumns, tileSize } = getSurfaceTileGridLayout(surfaceWidth);
  return { glyphColumns, surfaceColumns, surfaceWidth, tileSize };
}
